import React, { useState, useEffect } from 'react';
import '../styles/components/news-page.scss';
import { Link } from 'react-router-dom';
import { useNews, Article } from '../context/NewsContext';
import { baseURLnoapi } from '../Constants';
import PageHeader from '../components/PageHeader';

const NewsPage: React.FC = () => {
  // Get articles from context
  const { articles, isLoading, getNewsArticlesByTag } = useNews();
  const [filteredArticles, setFilteredArticles] = useState<Article[]>([]);
  const [activeFilter, setActiveFilter] = useState<string>('all');

  // Filter options
  const filterOptions = [
    { id: 'all', label: 'All News' },
    { id: 'Player News', label: 'Player News' },
    { id: 'Previous Events', label: 'Previous Events' },
    { id: 'Upcoming Events', label: 'Upcoming Events' },
    { id: 'NCS News', label: 'NCS News' },
    { id: 'Miscellaneous', label: 'Miscellaneous' }
  ];

  useEffect(() => {
    // Apply filter whenever activeFilter changes
    const applyFilter = async () => {
      const filtered = await getNewsArticlesByTag(activeFilter);
      setFilteredArticles(filtered);
    };
    
    applyFilter();
  }, [activeFilter, articles, getNewsArticlesByTag]);

  useEffect(() => {
    // Set page title
    document.title = 'News - Northern Championships Series';
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  const handleFilterClick = (filterId: string): void => {
    setActiveFilter(filterId);
  };

  return (
    <div className="news-page">
      <PageHeader 
        title="LATEST NEWS"
        subtitle="Stay updated with the latest Northern Championships Series news, player updates, and tournament announcements."
      >
        <div className="filter-buttons">
          {filterOptions.map(option => (
            <button 
              key={option.id}
              className={`filter-button ${activeFilter === option.id ? 'active' : ''}`}
              onClick={() => handleFilterClick(option.id)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </PageHeader>
      
      <div className="container">
        {/* Articles Grid */}
        {isLoading ? (
          <div className="loading">
            <div className="loading-spinner"></div>
          </div>
        ) : (
          <div className="news-grid">
            {filteredArticles.length > 0 ? (
              filteredArticles.map(article => (
                <article key={article.id} className="news-card">
                  <div className="news-image">
                    <img 
                      src={article.imageUrl?.startsWith('http') 
                        ? article.imageUrl 
                        : `${baseURLnoapi}${article.imageUrl}`} 
                      alt={article.title} 
                    />
                    <div className="news-category">{article.category}</div>
                  </div>
                  <div className="news-content">
                    <div className="news-date">{new Date(article.date).toLocaleDateString()}</div>
                    <h3>{article.title}</h3>
                    <p>{article.excerpt}</p>
                    <Link to={`/news/${article.id}`} className="read-more">
                      Read More
                    </Link>
                  </div>
                </article>
              ))
            ) : (
              <div className="no-results">
                <p>No articles found matching the selected filter.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsPage;